import { CustomError } from './CustomError';

export class UnexpectedError extends CustomError {
	constructor(message: string, error?: unknown, code?: string) {
		super(message, error, code ?? 'ERROR_UNEXPECTED');
	}
}
